import { useEffect, useState } from 'react';
import { Card } from './ui/card';
import { Target } from 'lucide-react';
import api from '../lib/api';

const inr = n => `₹${Math.round(n || 0).toLocaleString('en-IN')}`;

const Line = ({ label, value, pct, testid }) => (
  <div data-testid={testid}>
    <div className="flex justify-between text-xs"><span className="text-slate-500">{label}</span><span className="font-semibold text-slate-800">{inr(value)}{pct !== null && <span className="text-slate-400 font-normal"> · {pct}%</span>}</span></div>
    <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden mt-1"><div className="h-full bg-violet-600" style={{ width: `${Math.min(100, pct || 0)}%` }} /></div>
  </div>
);

export const MyTargetCard = () => {
  const [d, setD] = useState(null);
  const [q, setQ] = useState('');
  useEffect(() => { api.get('/trainer-targets/mine', { params: q ? { quarter: q } : {} }).then(r => setD(r.data)).catch(() => setD(false)); }, [q]);
  if (!d) return null;
  const r = d.row;
  return (
    <Card className="p-4 space-y-3" data-testid="my-target-card">
      <div className="flex items-center justify-between gap-2">
        <div className="text-sm font-bold text-slate-900 flex items-center gap-2"><Target className="w-4 h-4 text-violet-600" />My target</div>
        <select value={d.quarter.key} onChange={e => setQ(e.target.value)} className="h-7 text-xs border border-slate-200 rounded px-1 bg-white" data-testid="my-target-quarter">
          {d.quarters.map(x => <option key={x.key} value={x.key}>{x.label}{x.key === d.current ? ' (current)' : ''}</option>)}
        </select>
      </div>
      {!r || !r.target ? <p className="text-xs text-slate-400" data-testid="my-target-empty">Your target for {d.quarter.label} hasn't been set yet.</p> : <>
        <div className="text-2xl font-bold text-slate-900" data-testid="my-target-amount">{inr(r.target)}</div>
        <Line label="Billed" value={r.billed} pct={r.billed_pct} testid="my-target-billed" />
        <Line label="Collected" value={r.collected} pct={r.collected_pct} testid="my-target-collected" />
        <p className="text-[10px] text-slate-400">Counts fees of students in your batches that started in {d.quarter.label}.</p>
      </>}
    </Card>
  );
};
